import castArray from "lodash/fp/castArray";
import filter from "lodash/fp/filter";
import find from "lodash/fp/find";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import get from "lodash/fp/get";
import getOr from "lodash/fp/getOr";
import last from "lodash/fp/last";
import reduce from "lodash/reduce";

export default function getSkateCustomiseBladeValuesFromRecipe(recipeData) {
  return (productCustomisations) =>
    flow(
      flatMap(getOr([], "fields")),
      find(({ name }) => name === "Blade Type"),
      getOr([], "options"),
      find(({ value }) => value === recipeData["Blade Type"]),
      getOr([], "fields"),
      find(({ name }) => name === "SkateCustomiseBlade"),
      getOr([], ["props", "fields"]),
      flatMap(castArray),
      (fields) => {
        return reduce(
          {
            customizeBladeProfile: recipeData["Performance Radius"],
            customizeBladeSharpening: recipeData["Sharpening"],
          },
          (acc, value, key) => {
            return {
              ...acc,
              [key]: flow(
                find(({ name }) => name === key),
                getOr([], "options"),
                filter(
                  ({ fields = [] }) =>
                    fields.length === 0 ||
                    fields
                      .flatMap(getOr([], "options"))
                      .find((option) => option.value === value)
                ),
                last,
                get("value")
              )(fields),
            };
          },
          {}
        );
      }
    )(productCustomisations);
}
